export enum HeroVariation {
  HomePage = 'default',
  Heloc = 'heloc',
  PersonalLoans = 'personalLoans',
  ConsolidationLoans = 'consolidationLoans',
  OurClients = 'ourClients',
  LoanUses = 'loanUses',
  OurProcess = 'ourProcess',
  AboutUs = 'aboutUs',
  EngineLanding = 'engineLanding',
}
